import { NuxtAxiosInstance } from '@nuxtjs/axios'

type SortColumn = 'published_at' | 'last_clipped_at' | 'clips_count'

export function searchPortfolios(
  $axios: NuxtAxiosInstance,
  query: string,
  options: {
    page?: number
    per?: number
    sort?: SortColumn
  }
) {
  const params = {
    query,
    ...{
      page: 1,
      per: 15,
      ...options
    }
  }

  return $axios.get<Portfolio[]>('/v2/search/portfolios', { params })
}

export function searchClippingPortfolios(
  $axios: NuxtAxiosInstance,
  query: string,
  options: {
    page?: number
    per?: number
    sort?: SortColumn
  }
) {
  const params = {
    query,
    ...{
      page: 1,
      per: 15,
      ...options
    }
  }

  return $axios.get<Portfolio[]>('/v2/portfolios/clipping', { params })
}

export function getPortfolioThumbnailUrl(portfolio: Portfolio) {
  return portfolio.portfolio_image.thumb_760.url
}
